<template>
   <div>
      <div class="overlay" :class="{ show: isOpen }" @click="isOpen = !isOpen"></div>

      <div class="app-settings" :class="{ active: isOpen }">
         <a href="javascript:;" id="settingbutton" class="setting" @click="isOpen = !isOpen">
            <h5 class="mb-0">
               <span>{{ items.length }}</span>
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
               </svg>
            </h5>
         </a>
         <perfect-scrollbar class="sidbarchat p-3" tag="div">
            <a class="btn-close" href="javascript:;" @click="isOpen = !isOpen">
               <svg
                 xmlns="http://www.w3.org/2000/svg"
                 width="20"
                 height="20"
                 viewBox="0 0 24 24"
                 fill="none"
                 stroke="currentColor"
                 stroke-width="2"
                 stroke-linecap="round"
                 stroke-linejoin="round"
                 class="feather feather-x"
               >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
               </svg>
            </a>
            <h5 class="mb-0 text-center">{{ $t("selected_items") }}</h5>
            <hr />
            <div v-for="item in items" :key="item.id" class="cart-products-card">
               <div class="cart-products-card-item">
                  <img v-if="item.attachments?.[0]" :src="url + '/' + item.attachments[0].file_path" loading="lazy" />
                  <svg v-else
                       xmlns="http://www.w3.org/2000/svg"
                       width="24" height="24"
                       viewBox="0 0 24 24"
                       fill="none"
                       stroke="currentColor"
                       stroke-width="2"
                       stroke-linecap="round"
                       stroke-linejoin="round">
                     <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                     <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                     <line x1="12" y1="22.08" x2="12" y2="12" />
                  </svg>
                  <h6>{{ item.name }}</h6>
               </div>
               <div class="remove-btn" @click="$emit('remove', item)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="feather feather-x"
                  >
                     <line x1="18" y1="6" x2="6" y2="18"></line>
                     <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
               </div>

            </div>
            <div class="text-center mt-4" v-if="items.length > 0">
               <b-button variant="outline-danger" @click="$emit('clear')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2" data-v-5522efca="">
                     <polyline points="3 6 5 6 21 6"></polyline>
                     <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                     <line x1="10" y1="11" x2="10" y2="17"></line>
                     <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                  {{ $t("clear_all") }}
               </b-button>
            </div>


         </perfect-scrollbar>
      </div>
   </div>
</template>
<script>
   import { urlMixin } from "@/mixins/url";

   export default {
      data() {
         return {
            isOpen: null
         };
      },
      mixins: [urlMixin],
      props: {
         items: {
            type: Array,
            default: () => []
         }
      },
      emits: ["remove", "clear"],
      mounted() {
         //set default values from local storage
         this.setTemplateStyle();
         this.setMenuStyle();
         this.setLayoutStyle();
      },

      methods: {
         setTemplateStyle() {
            this.$store.commit("toggleDarkMode", this.$store.state.dark_mode);
         },

         setMenuStyle() {
            this.$store.commit("toggleMenuStyle", this.$store.state.menu_style);
         },

         setLayoutStyle() {
            this.$store.commit("toggleLayoutStyle", this.$store.state.layout_style);
         }
      }
   };
</script>

<style scoped lang="scss">
   .cart-products-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      margin-bottom: 1rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid #f1f2f3;

      &:last-child {
         border-bottom: none;
      }

      .cart-products-card-item {
         display: flex;
         align-items: center;
         gap: 1rem;

         img {
            width: 3rem;
            height: 3rem;
            object-fit: cover;
            border-radius: 0.4rem;
         }

         svg {
            width: 3rem;
            height: 2rem;
         }

         h6 {
            margin-bottom: 0;
         }
      }

      .remove-btn {
         cursor: pointer;

         &:hover {
            color: var(--dark);
         }
      }

   }


   .dark {
      .cart-products-card {
         border-bottom: 1px solid #191e3a;
      }
   }
</style>
